// src/GlobalStyle.js
import { createGlobalStyle } from 'styled-components';

import imgBg from "../images/grunge-paper-background.jpg";

const GlobalStyle = createGlobalStyle`
  * {
    //font-family: monospace, sans-serif;
    font-family: 'Paragraph', monospace, sans-serif;
    line-height:1.3em;
    margin: 0;
    padding: 0;
  }

  :root {
    --bg: #2a1d0d;
    --links: #eefb26;
    --text:#d3b952;
    --text-header:#d1ce34;

    --gray-900: #2d2d2d;
    --camo-200: #c3d4a5;
    --yellow-100: #fcfdc7;
    --gray-700: #646464;
    --black: black;
    --camo-300: #9ba885;
    --yellow-300: #fcfc03;
    --camo-700: #11140c;
    --camo-400: #75835d;
    --gray-975: #0d0d0d;
    --lime-300: #98dd28;
    --mars-300: #ed4e1d;
    --gray-400: #c9c9c9;
    --camo-500: #404833;
    --white: white;
    --gray-800: #474747;
    --gray-600: #8b8b8b;
    --gray-500: #a8a8a8;
    --gray-300: #d9d9d9;
    --gray-200: #e1e1e1;
    --camo-600: #252b1b;
    --yellow-600: #7b7638;
    --mars-400: #c53b10;
  }

  body {

    background-color: var(--bg);
    position: relative;
    
    color: var(--text);
  }

body::before {
  content: '';
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: url(${imgBg});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  pointer-events: none;
  z-index: -2;
}

body::after {
  content: '';
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background:
    linear-gradient(rgba(12, 8, 2, 0.89), rgba(12, 8, 2, 0.89)),
    radial-gradient(ellipse at center, transparent 60%, rgba(0, 0, 0, 0.8) 95%, rgba(0, 0, 0, 0.9) 100%);
  pointer-events: none;
  z-index: -1;
}


/*
body::after {
  content: '';
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border: 1px solid var(--yellow-600);
  pointer-events: none;
  z-index: 9999;
  box-sizing: border-box;
  border-radius: 15px;
  margin: 12px;
}*/


  p {
    color: var(--text);
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.8);
  }

  h1, h2, h3, h4 {
    font-family: 'Header', sans-serif;
    color: var(--text-header);
    font-weight: bold;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 1.0);
  }

  h2 {
  font-size: 1.8em;
  }

  a {
    color: var(--links);
    text-decoration:none;
  }

  a:hover {
    text-decoration:underline;
  }

  hr {
    border: none;
    margin: 0em 0 0.5em 0;
    height: 1px;
    background-color:var(--yellow-600);
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.9);
  }
`;

export default GlobalStyle;
